import TableLoader from "../../../../general/table/tableLoader";
import EmptyRow from "../../../../general/table/emptyRow";
import React from "react";
import PatientConditionTableRowItem from "./patientConditionTable_rowItem";

type PatientConditionsTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean;
  readonly: boolean;
}

const PatientConditionsTable = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly = false
}: PatientConditionsTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
      return <PatientConditionTableRowItem item={item} key={i} readonly={readonly}/>
    });

  return (
    <table>
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default PatientConditionsTable;
